import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Star, BadgeCheck } from 'lucide-react';
import { fmtRM2 } from '../../data/mockData';
import { useApp } from '../../context/AppContext';
import { fileUrl } from '../../lib/upload';

export function ProductCard({ product }) {
  const { favourites, toggleFavourite, merchantById } = useApp();
  const merchant = merchantById(product.merchantId);
  const isFav = favourites.includes(product.id);
  return (
    <div
      data-testid={`product-card-${product.slug}`}
      className="group flex flex-col rounded-3xl bg-kelate-surface p-2.5 shadow-[0_1px_4px_rgba(81,68,55,0.08)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_10px_28px_rgba(81,68,55,0.14)]"
    >
      <div className="relative overflow-hidden rounded-2xl bg-[#EFEAE2]">
        <Link to={`/product/${product.slug}`} className="block">
          <img
            src={fileUrl(product.image)}
            alt={product.name}
            className="aspect-square w-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        </Link>
        <div className="absolute left-3 top-3 flex flex-col items-start gap-1.5">
          {(product.badges || []).slice(0, 2).map((b) => (
            <span key={b} className="rounded-full bg-kelate-darkwood/90 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-kelate-surface backdrop-blur-sm">
              {b}
            </span>
          ))}
        </div>
        <button
          data-testid={`fav-${product.slug}`}
          onClick={() => toggleFavourite(product.id)}
          className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-kelate-surface shadow-[0_1px_4px_rgba(81,68,55,0.15)] transition-transform hover:scale-110"
          aria-label="Favourite"
        >
          <Heart size={15} className={isFav ? 'fill-kelate-red text-kelate-red' : 'text-kelate-darkwood'} />
        </button>
      </div>
      <div className="flex flex-1 flex-col px-2.5 pb-2 pt-3">
        <Link to={`/product/${product.slug}`} className="line-clamp-1 text-sm font-semibold text-kelate-ink transition-colors hover:text-kelate-darkwood">
          {product.name}
        </Link>
        {merchant && (
          <Link to={`/store/${merchant.slug}`} className="mt-0.5 flex items-center gap-1 text-xs text-kelate-soft transition-colors hover:text-kelate-wood">
            {merchant.name}
            {merchant.verified && <BadgeCheck size={12} className="text-kelate-sage" />}
          </Link>
        )}
        <div className="mt-1.5 flex items-baseline gap-2" data-testid="price-display">
          <span className="text-base font-bold tracking-tight text-kelate-ink">{fmtRM2(product.price)}</span>
          {product.originalPrice && product.originalPrice > product.price && (
            <span className="text-xs text-kelate-soft/70 line-through">{fmtRM2(product.originalPrice)}</span>
          )}
        </div>
        <div className="mt-1.5 flex items-center gap-1 text-[11px] text-kelate-soft">
          <Star size={11} className="fill-kelate-wood text-kelate-wood" />
          <span className="font-medium text-kelate-ink">{product.rating}</span>
          <span>· {product.sold} sold · {product.district}</span>
        </div>
      </div>
    </div>
  );
}
